import { Service } from '@/tools'
export class AssistService<T extends TCommodity.Assist> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Assist}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  // 创建  基本信息 批量提交并新建
  batchSaveSubmitBasicInformation = <K extends T['ApiBatchAssistSaveSubmitBasicInformation']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiBatchAssistSaveSubmitBasicInformation', data)

  // 创建  图文信息 批量提交并新建
  batchSaveSubmit = <K extends T['ApiBatchAssistSaveSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBatchAssistSaveSubmit', data)

  // 创建  图文信息 提交并新建
  saveSubmit = <K extends T['ApiSaveAssistSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSaveAssistSubmit', data)

  // 编辑 修改  基本信息 批量保存
  batchUpdateBasicInformation = <K extends T['ApiBatchAssistUpdateBasicInformation']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiBatchAssistUpdateBasicInformation', data)

  // 编辑 修改  图文信息 保存
  update = <K extends T['ApiUpdateAssist']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateAssist', data)

  // 编辑 修改  图文信息 批量保存
  batchUpdate = <K extends T['ApiBatchAssistUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBatchAssistUpdate', data)

  // 查看详情
  selectCommodityDetail = <K extends T['ApiSelectCommodityAssistDetail']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectCommodityAssistDetail', data)
}
